var check_all = ( function( $ ) {

	var _init = function() {
		var $all_link = $( '.checkall li:first-child input' );

		$all_link.on( 'click', _toggle_all );
	};

	var _toggle_all = function() {
		$( this ).parent( 'li' ).parent( 'ul' ).find( ':checkbox' ).attr( 'checked', this.checked );
	};

	if ( $( '.gfield.checkall' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

} )( jQuery );

module.exports = check_all;